import Vue from 'vue'

import CrmAddress from './CrmAddress.vue'

Vue.component('CrmAddress', CrmAddress)
